import { Euler, Matrix4, Quaternion, Vector3 } from "three"

// export function rotationFromZAxis(direction: number[]): Quaternion {
//   const dir = new Vector3(direction[0], direction[1], direction[2]).normalize();
//   const zAxis = new Vector3(0, 0, 1);
//   const quaternion = new Quaternion();
//   quaternion.setFromUnitVectors(zAxis, dir);
//   return quaternion;
// }

// export function eulerFromQuaternion(quaternion: Quaternion) {
//   const euler = new Euler()
//   euler.setFromQuaternion(quaternion)
//   return euler
// }

// export function rotationFromZAxis(direction: number[]): Vector3 {
//   // Normalize direction
//   const dir = new Vector3(direction[0], direction[1], direction[2]).normalize();
//   // Asse Z locale
//   const zAxis = new Vector3(0, 0, 1);

//   // Calcola quaternion che ruota zAxis verso dir
//   const quaternion = new Quaternion();
//   quaternion.setFromUnitVectors(zAxis, dir)

//   // Converti quaternion in Euler per react-three-fiber
//   const euler = new Euler().setFromQuaternion(quaternion);

//   return new Vector3(euler.x, euler.y, euler.z);
// }

export function computeOrientation(direction: number[]): number[] {
    const z = new Vector3(direction[0], direction[1], direction[2]).normalize()

    // X globale (da mantenere come direzione della sezione)
    const globalX = new Vector3(1, 0, 0)

    // Proietta globalX sul piano ortogonale a Z → questo sarà il nuovo asse X locale
    const x = globalX.clone().projectOnPlane(z).normalize()

    // Se x.length() è 0 (cioè Z è parallelo a X), allora usiamo Y per evitare degenerazione
    if (x.lengthSq() < 1e-6) {
        const globalY = new Vector3(0, 1, 0)
        x.copy(globalY.clone().projectOnPlane(z).normalize())
    }

    // Y locale = Z × X (prodotto vettoriale → sistema ortogonale destrorso)
    const y = new Vector3().crossVectors(z, x).normalize()

    // Costruisci la matrice di rotazione dai 3 assi
    const matrix = new Matrix4().makeBasis(x, y, z)

    // Converti in quaternion
    const quaternion = new Quaternion().setFromRotationMatrix(matrix)
    const euler = new Euler().setFromQuaternion(quaternion)

    return [euler.x, euler.y, euler.z]
}